import router from '../../router/index'
import axios from 'axios'
import * as errorMapping from '../errorMessageMapping'
import { dateHelpers } from '../../helpers/dateHelpers.js'
// import store from "../index";
// import store from '../index'
// import store from '../../store'

export default {
    LOGIN ({ commit }, { user }) {
        user.email = user.email.toLowerCase()
        commit('setError', { error: { show: false, message: '' } })
        return axios.post('login/authenticate', user).then((response) => {
            const { data: { data } } = response
            // console.log('user response', response)
            let userToken = response.headers.authorization
            if (data && !data.error && data.completed) {
                localStorage.setItem('token', userToken)
                localStorage.setItem('loggedUser', JSON.stringify(data.payload))
                commit('setUser', { user: data.payload })
                // Log the SignIn Event
                let userPayloadSignIn = {}
                userPayloadSignIn.userId = data.payload.userId
                userPayloadSignIn.action = `LOGIN`
                userPayloadSignIn.activityCode = null
                userPayloadSignIn.activityMessage = 'AUTHORIZED'
                userPayloadSignIn.severityLevel = 'INFORMATION'
                userPayloadSignIn.status = null
                userPayloadSignIn.timeZone = dateHelpers.getUserTimeZone()
                userPayloadSignIn.pageName = null
                userPayloadSignIn.os = dateHelpers.userPlatForm().os.family
                userPayloadSignIn.osVersion = dateHelpers.userPlatForm().os.version
                userPayloadSignIn.browserName = dateHelpers.userPlatForm().name
                userPayloadSignIn.browserVersion = dateHelpers.userPlatForm().version
                userPayloadSignIn.device = dateHelpers.userPlatForm().product
                userPayloadSignIn.deviceType = null
                // Additional logging
                userPayloadSignIn.userAgent = navigator.userAgent
                if (navigator.userAgent.indexOf('gonative') > -1) {
                    // IOS App
                    userPayloadSignIn.deviceType = 'IOS APP'
                } if (navigator.userAgent.indexOf('gonativeand') > -1) {
                    // Andoird App
                    userPayloadSignIn.deviceType = 'ANDROID APP'
                }
                return axios.post('/logging/writeActivityToQueue', userPayloadSignIn).then((response) => {
                    console.log('successfully logged-IE: ', response)
                    if (sessionStorage.getItem('redirectPath')) {
                        setTimeout(() => {
                            let redirection = sessionStorage.getItem('redirectPath')
                            if (redirection.toString().toLowerCase().indexOf('playlistshare') > -1) {
                                router.push(sessionStorage.getItem('redirectPath'))
                                sessionStorage.removeItem('redirectPath')
                                window.location.reload()
                            } else {
                                router.push(sessionStorage.getItem('redirectPath'))
                                sessionStorage.removeItem('redirectPath')
                                window.location.reload()
                            }
                        }, 200)
                    } else {
                        commit('setError', { error: { show: false, message: '' } })
                        //
                        //
                        //
                        let eventCorporationId = ''
                        let eventRedirectUri = ''
                        if (localStorage.getItem('event_corporation_id')) {
                            eventCorporationId = localStorage.getItem('event_corporation_id')
                        }
                        if (localStorage.getItem('event_redirect_uri')) {
                            eventRedirectUri = localStorage.getItem('event_redirect_uri')
                        }
                        if (eventCorporationId !== '' && eventRedirectUri !== '') {
                            // Remove any trailing slash
                            eventRedirectUri = eventRedirectUri.replace(/\/$/, '')
                            // Extract the part after the last slash
                            const parts = eventRedirectUri.split('/')
                            let eventId = parts[parts.length - 1]
                            console.log('4A===================================>  EVENT ID = ', eventId)
                            //
                            router.push('/event/' + eventId)
                            if (localStorage.getItem('event_corporation_id')) {
                                localStorage.removeItem('event_corporation_id')
                            }
                            if (localStorage.getItem('event_redirect_uri')) {
                                localStorage.removeItem('event_redirect_uri')
                            }
                            //
                        } else {
                            if (data.payload && data.payload.corporation && data.payload.corporation.landingPage && data.payload.corporation.landingPage.length > 2 && data.payload.corporation.landingPage.indexOf('/') > -1) {
                                router.push(data.payload.corporation.landingPage)
                            } else {
                                router.push('/mytone')
                            }
                        }
                        window.location.reload()
                    }
                }, (err) => {
                    console.log('err in logging ', err)
                    if (sessionStorage.getItem('redirectPath')) {
                        setTimeout(() => {
                            let redirection = sessionStorage.getItem('redirectPath')
                            if (redirection.toString().toLowerCase().indexOf('playlistshare') > -1) {
                                router.push(sessionStorage.getItem('redirectPath'))
                                sessionStorage.removeItem('redirectPath')
                                window.location.reload()
                            } else {
                                router.push(sessionStorage.getItem('redirectPath'))
                                sessionStorage.removeItem('redirectPath')
                                window.location.reload()
                            }
                        }, 200)
                    } else {
                        commit('setError', { error: { show: false, message: '' } })
                        if (data.payload && data.payload.corporation && data.payload.corporation.landingPage && data.payload.corporation.landingPage.length > 2 && data.payload.corporation.landingPage.indexOf('/') > -1) {
                            router.push(data.payload.corporation.landingPage)
                        } else {
                            router.push('/mytone')
                        }
                    }
                })
            } else {
                console.log('error returned', data)
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message), originalMessage: data.message } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    VERIFYUSEREXISTS ({ commit }, { email }) {
        return axios.get(`/registration/getExistingUser/${email}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } })
                // dispatch('ME')
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    CHECKUSEREXISTS ({ commit }, { email }) {
        return axios.get(`/registration/getByEmail/${email}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed && data.payload !== null && data.message === 'completed') {
                commit('setError', { error: { show: false, message: '' } })
                // commit('setCheckUSer', {expert: data.payload})
                // dispatch('ME')
            } else {
                // commit('setCheckUSer', {expert: data.payload})
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            // commit('setCheckUSer', {expert: data.payload})
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    UPDATEUSERPAYLOAD ({ commit }, userId) {
        return axios.get(`/profile/getUserPaymentInfo/${userId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                localStorage.setItem('loggedUser', JSON.stringify(data.payload))
                if (sessionStorage.getItem('loggedUserTemp')) {
                    sessionStorage.removeItem('loggedUserTemp')
                }
                if (data.payload.corporation && sessionStorage.getItem('switchClientObject')) { // Corporate User with Switching enabled
                    let switchedCorp = sessionStorage.getItem('switchClientObject')
                    switchedCorp = JSON.parse(switchedCorp)
                    data.payload.corporation = switchedCorp // Switch Corporation Object
                    // let headerColor = '#f0617d'
                    // let footerColor = '#f0617d'
                    // let buttonColor = '#f0617d'
                    // let headingColor = '#f0617d'
                    let headerColor = '#44bda8'
                    let footerColor = '#44bda8'
                    let buttonColor = '#44bda8'
                    let headingColor = '#44bda8'
                    if (data.payload.corporation.groupDefinitions && data.payload.corporation.groupDefinitions.headerColor) {
                        headerColor = data.payload.corporation.groupDefinitions.headerColor
                    }
                    if (data.payload.corporation.groupDefinitions && data.payload.corporation.groupDefinitions.footerColor) {
                        footerColor = data.payload.corporation.groupDefinitions.footerColor
                    }
                    if (data.payload.corporation.groupDefinitions && data.payload.corporation.groupDefinitions.buttonColor) {
                        buttonColor = data.payload.corporation.groupDefinitions.buttonColor
                    }
                    if (data.payload.corporation.groupDefinitions && data.payload.corporation.groupDefinitions.headingColor) {
                        headingColor = data.payload.corporation.groupDefinitions.headingColor
                    }
                    commit('setCorpHeaderColor', headerColor)
                    commit('setCorpFooterColor', footerColor)
                    commit('setCorpButtonColor', buttonColor)
                    commit('setCorpHeadingColor', headingColor)
                    commit('setUser', { user: data.payload }) // Trigger The change
                } else {
                    commit('setUser', { user: data.payload })
                }
            }
        }, (err) => {
            console.log('err ', err)
        })
    },
    VERIFYUSERSTATUS ({ commit }, email) {
        return axios.put(`/registration/validateUserEmailStatus/${email}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setValidationStatusError', true)
                // dispatch('ME')
            } else {
                commit('setValidationStatusError', false)
            }
        }, (err) => {
            console.log('err ', err)
            // commit('setError', { error: {show: true, message: 'An error occurred while processing the request'} })
        })
    },
    VALIDATE ({ commit }, { user }) {
        return axios.put(`/registration/validateUserEmail/${user.email}/${user.validationCode}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                // localStorage.setItem('token', authorization)
                // dispatch('ME')
                // router.push('/login')
                commit('setError', { error: { show: false, message: '' } })
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    FORGOTPASSWORD ({ commit }, { user }) {
        commit('setError', { error: { show: false, message: '' } })
        return axios.get(`/login/forget-password/${user.email.toLowerCase()}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } })
                // router.push(`/resetpassword/${user.email}`)
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            // commit('setError', { error: {show: true, message: 'An error occurred while processing the request'} })
        })
    },
    CONFIRMPASSWORD ({ commit }, { user }) {
        return axios.post('/login/confirm-forget-password', user).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } })
                router.push('/')
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    UPDATE_USER_PREFERENCES ({ commit }, { user }) {
        return axios.post('/registration/updateTeaserTakeAwayOptOutFlag', user).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } })
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    UPDATEPROFILEPASSWORD ({ commit }, { passwords }) {
        return axios.post('/login/reset-password', passwords).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } })
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    EMAILSHAREPLAYLIST ({ commit }, { payload }) {
        return axios.post('/playlists/sharePlaylist', payload).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } })
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    EMAILSHAREVIDEO ({ commit }, { payload }) {
        return axios.post('/playlists/shareVideoByUser', payload).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } })
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    ARCHIVE_PLAYLIST_SHARE ({ commit }, { payload }) {
        return axios.post('/playlists/shareArchivePlaylist', payload).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } })
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    VIDEOCORPORATESHARE ({ commit }, { payload }) {
        return axios.post('/corporations/sendVideoSharingLetter', payload).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } })
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    PLAYLISTCORPORATESHARE ({ commit }, { payload }) {
        return axios.post('/playlists/sharePlaylistForCorp', payload).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } })
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    CORP_EVENT_SHARE ({ commit }, { payload }) {
        return axios.post('/playlists/shareEvent', payload).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } })
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    UPDATEPROFILEEMAIL ({ commit }, { payload }) {
        return axios.post('/registration/changeUserEmail', payload).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } })
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    USERINFO ({ commit }, { userInfo }) {
        commit('setUser', { user: userInfo })
        router.push('/topic')
    },
    SIGNUP ({ commit }, { user }) {
        return axios.post('registration/add-user', user).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed && data.message !== 'tone.user.AlreadyExists') {
                // console.log('reg payload', data.payload)
                commit('setUser', { user: data.payload })
                sessionStorage.setItem('loggedUserTemp', JSON.stringify(data.payload))
                commit('setError', { error: { show: false, message: '' } })
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    SIGNUPWITHPAYMENTPLAN ({ commit }, { user }) {
        return axios.post('registration/addNewUser', user, { headers: { 'tone-user': user.email } }).then((response) => {
            const { data: { data } } = response
            let userToken = response.headers.authorization
            if (data && !data.error && data.completed) {
                commit('setUser', { user: data.payload })
                sessionStorage.setItem('loggedUserTemp', JSON.stringify(data.payload))
                localStorage.setItem('token', userToken)
                commit('setError', { error: { show: false, message: '' } })
                router.push('/interests')
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    CHANGEFREEPREVIEWTOREGULAR ({ commit }, { user }) {
        return axios.post('registration/changeFreePrevToRegular', user, { headers: { 'tone-user': user.email } }).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                // Update user profile at client
                commit('setUser', { user: data.payload })
                let loggedUser = localStorage.getItem('loggedUser')
                let loggedUserTemp = sessionStorage.getItem('loggedUserTemp')
                if (loggedUser) {
                    localStorage.setItem('loggedUser', JSON.stringify(data.payload))
                }
                if (loggedUserTemp) {
                    sessionStorage.setItem('loggedUserTemp', JSON.stringify(data.payload))
                }
                commit('setHeaderAlertStatus', false)
                commit('setTrialDays', 10000000)
                commit('setError', { error: { show: false, message: '' } })
                router.push('/mytone')
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    CHANGE_FREEP_REVIEW_TO_REGULAR_NOVO ({ commit }, { user }) {
        console.log('user to update', user)
        return axios.post('corporations/oneTimeNordiskCharge', user, { headers: { 'tone-user': user.email } }).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                // Update user profile at client
                console.log('returned profile after update', data.payload)
                commit('setUser', { user: data.payload })
                let loggedUser = localStorage.getItem('loggedUser')
                let loggedUserTemp = sessionStorage.getItem('loggedUserTemp')
                if (loggedUser) {
                    localStorage.setItem('loggedUser', JSON.stringify(data.payload))
                }
                if (loggedUserTemp) {
                    sessionStorage.setItem('loggedUserTemp', JSON.stringify(data.payload))
                }
                commit('setHeaderAlertStatus', false)
                commit('setTrialDays', 10000000)
                commit('setError', { error: { show: false, message: '' } })
                router.push('/mytone')
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    PROCESSCORPORATEPAYMENT ({ commit }, { user }) {
        return axios.post('corporations/processCorporationSales', user).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                // Update user profile at client
                // router.push('/')
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    SAVEUSERWITHFREETIRAL ({ commit }, { newUser }) {
        return axios.post('freepreview/addNewUserFreePreview', newUser, { headers: { 'tone-user': newUser.email } }).then((response) => {
            const { data: { data } } = response
            let userToken = response.headers.authorization
            if (data && !data.error && data.completed) {
                commit('setUser', { user: data.payload })
                sessionStorage.setItem('loggedUserTemp', JSON.stringify(data.payload))
                localStorage.setItem('token', userToken)
                commit('setError', { error: { show: false, message: '' } })
                router.push('/interests')
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    UPDATECREDITCARD ({ commit }, user) {
        return axios.post('/profile/addCard', user).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setUser', { user: data.payload })
                localStorage.setItem('loggedUser', JSON.stringify(data.payload))
                commit('setCardExpiryDays', 100)
                commit('setError', { error: { show: false, message: '' } })
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    SUBSCRIBE ({ commit }, { userPaymentInfo }) {
        return axios.post('/registration/add-plan', userPaymentInfo[0], { headers: { 'tone-user': userPaymentInfo[0].email } }).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                return axios.post(`/registration/add-payment/${userPaymentInfo[0].userPayments[0].token}/${userPaymentInfo[0].userPayments[0].stripeCardId}/${userPaymentInfo[1]}`, userPaymentInfo[0], { headers: { 'tone-user': userPaymentInfo[0].email } }).then((response) => {
                    const { data: { data } } = response
                    if (data && !data.error && data.completed) {
                        commit('setError', { error: { show: false, message: '' } })
                        router.push('/interests')
                    } else {
                        commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
                    }
                })
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    SETINTERESTS ({ commit }, { interests }) {
        return axios.post('/interests', interests).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                if (sessionStorage.getItem('redirectPath')) {
                    router.push(sessionStorage.getItem('redirectPath'))
                    sessionStorage.removeItem('redirectPath')
                } else {
                    // let loggedUser = localStorage.getItem('loggedUser')
                    let loggedUser = null
                    if (localStorage.getItem('loggedUser')) {
                        loggedUser = JSON.parse(localStorage.getItem('loggedUser'))
                    }
                    // let loggedUserTemp = sessionStorage.getItem('loggedUserTemp')
                    let loggedUserTemp = null
                    if (sessionStorage.getItem('loggedUserTemp')) {
                        loggedUserTemp = JSON.parse(sessionStorage.getItem('loggedUserTemp'))
                    }
                    let defaultLandingPage = '/mytone'
                    if (loggedUserTemp) {
                        if (loggedUserTemp.corporation && loggedUserTemp.corporation.landingPage.length > 2 && loggedUserTemp.corporation.landingPage.indexOf('/') > -1) {
                            defaultLandingPage = loggedUserTemp.corporation.landingPage
                            router.push(defaultLandingPage)
                        } else {
                            router.push(defaultLandingPage)
                        }
                    }
                    if (loggedUser) {
                        if (loggedUser.corporation && loggedUser.corporation.landingPage.length > 2 && loggedUser.corporation.landingPage.indexOf('/') > -1) {
                            defaultLandingPage = loggedUser.corporation.landingPage
                            router.push(defaultLandingPage)
                        } else {
                            router.push(defaultLandingPage)
                        }
                    }
                    console.log('users -> actions.js  defaultLandingPage = ', defaultLandingPage)
                }
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    SETDAYS ({ commit }, { data }) {
        return axios.post(`user/email-delivery-days/users/${data.userId}`, data.days).then((response) => {
            console.log(response)
        })
    },
    UPDATEUSERPROFILE ({ commit }, userProfile) {
        return axios.put('/profile', userProfile).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                let loggedUserTemp = sessionStorage.getItem('loggedUserTemp') // User needs to be redirected to login (temporary) after interests are set
                if (loggedUserTemp) {
                    sessionStorage.removeItem('loggedUserTemp')
                    sessionStorage.setItem('loggedUserTemp', JSON.stringify(userProfile))
                    commit('setUser', { user: data.payload })
                } else {
                    localStorage.removeItem('loggedUser')
                    localStorage.setItem('loggedUser', JSON.stringify(userProfile))
                    commit('setUser', { user: data.payload })
                }
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    UPDATEUSERSTATE ({ commit }) {
        let loggedUser = localStorage.getItem('loggedUser')
        if (loggedUser) {
            this.$store.commit('setUser', { user: loggedUser })
        }
    },
    LOGUSERACTIVITY ({ commit }, userRef) {
        let userId = userRef[0] ? userRef[0] : 0
        let userPayload = {}
        userPayload.userId = userId
        userPayload.action = `USER_NAVIGATION`
        userPayload.activityCode = null
        userPayload.activityMessage = userId > 0 ? 'AUTHORIZED' : 'UNAUTHORIZED'
        userPayload.severityLevel = 'INFORMATION'
        userPayload.status = null
        userPayload.timeZone = dateHelpers.getUserTimeZone()
        userPayload.pageName = userRef[1]
        userPayload.os = dateHelpers.userPlatForm().os.family
        userPayload.osVersion = dateHelpers.userPlatForm().os.version
        userPayload.browserName = dateHelpers.userPlatForm().name
        userPayload.browserVersion = dateHelpers.userPlatForm().version
        userPayload.device = dateHelpers.userPlatForm().product
        userPayload.deviceType = null
        // Additional logging
        userPayload.userAgent = navigator.userAgent
        if (navigator.userAgent.indexOf('gonative') > -1) {
            // IOS App
            userPayload.deviceType = 'IOS APP'
        } if (navigator.userAgent.indexOf('gonativeand') > -1) {
            // Andoird App
            userPayload.deviceType = 'ANDROID APP'
        }
        return axios.post('/logging/writeActivityToQueue', userPayload).then((response) => {
        }, (err) => {
            console.log('activity log err ', err)
        })
    },
    LOG_USER_WITHIN_PAGE_CLICK ({ commit }, userRef) {
        let userId = userRef[0] ? userRef[0] : 0
        let userPayload = {}
        userPayload.userId = userId
        userPayload.action = userRef[2]
        userPayload.activityCode = userRef[3]
        userPayload.activityMessage = userId > 0 ? 'AUTHORIZED' : 'UNAUTHORIZED'
        userPayload.severityLevel = 'INFORMATION'
        userPayload.status = null
        userPayload.timeZone = dateHelpers.getUserTimeZone()
        userPayload.pageName = userRef[1]
        userPayload.os = dateHelpers.userPlatForm().os.family
        userPayload.osVersion = dateHelpers.userPlatForm().os.version
        userPayload.browserName = dateHelpers.userPlatForm().name
        userPayload.browserVersion = dateHelpers.userPlatForm().version
        userPayload.device = dateHelpers.userPlatForm().product
        userPayload.deviceType = null
        // Additional logging
        userPayload.userAgent = navigator.userAgent
        if (navigator.userAgent.indexOf('gonative') > -1) {
            // IOS App
            userPayload.deviceType = 'IOS APP'
        } if (navigator.userAgent.indexOf('gonativeand') > -1) {
            // Andoird App
            userPayload.deviceType = 'ANDROID APP'
        }
        console.log('banner click payload', userPayload)
        return axios.post('/logging/writeActivityToQueue', userPayload).then((response) => {
        }, (err) => {
            console.log('activity log err ', err)
        })
    },
    LOGOUT ({ commit }, userRef) {
        let userId = userRef ? userRef.userId : 0
        let userPayload = {}
        userPayload.userId = userId
        userPayload.action = `LOGOUT`
        userPayload.activityCode = null
        userPayload.activityMessage = 'AUTHORIZED'
        userPayload.severityLevel = 'INFORMATION'
        userPayload.status = null
        userPayload.timeZone = dateHelpers.getUserTimeZone()
        userPayload.pageName = null
        userPayload.os = dateHelpers.userPlatForm().os.family
        userPayload.osVersion = dateHelpers.userPlatForm().os.version
        userPayload.browserName = dateHelpers.userPlatForm().name
        userPayload.browserVersion = dateHelpers.userPlatForm().version
        userPayload.device = dateHelpers.userPlatForm().product
        userPayload.deviceType = null
        // Additional logging
        userPayload.userAgent = navigator.userAgent
        if (navigator.userAgent.indexOf('gonative') > -1) {
            // IOS App
            userPayload.deviceType = 'IOS APP'
        } if (navigator.userAgent.indexOf('gonativeand') > -1) {
            // Andoird App
            userPayload.deviceType = 'ANDROID APP'
        }
        if (sessionStorage.getItem('corporateGiftingCode')) {
            sessionStorage.removeItem('corporateGiftingCode')
        }
        if (localStorage.getItem('corporateGiftingCode')) {
            localStorage.removeItem('corporateGiftingCode')
        }
        if (sessionStorage.getItem('corporateClientObject')) {
            sessionStorage.removeItem('corporateClientObject')
        }
        if (localStorage.getItem('corporateClientObject')) {
            localStorage.removeItem('corporateClientObject')
        }
        if (sessionStorage.getItem('corporateGiftInfoObject')) {
            sessionStorage.removeItem('corporateGiftInfoObject')
        }
        if (localStorage.getItem('corporateGiftInfoObject')) {
            localStorage.removeItem('corporateGiftInfoObject')
        }
        if (sessionStorage.getItem('corporateClientId')) {
            sessionStorage.removeItem('corporateClientId')
        }
        if (localStorage.getItem('corporateClientId')) {
            localStorage.removeItem('corporateClientId')
        }
        localStorage.removeItem('token')
        sessionStorage.removeItem('token')
        localStorage.removeItem('loggedUser')
        // localStorage.removeItem('corporateClientObject')
        sessionStorage.removeItem('switchClientObject')
        sessionStorage.removeItem('redirectPath')
        let loggedUserTemp = sessionStorage.getItem('loggedUserTemp') // User needs to be redirected to login (temporary) after interests are set
        if (loggedUserTemp) {
            sessionStorage.removeItem('loggedUserTemp')
        }

        commit('setUser', { user: null })
        commit('setHeaderAlertStatus', false)
        commit('setCorpHeaderColor', '#44bda8')
        commit('setCorpFooterColor', '#44bda8')
        commit('setCorpButtonColor', '#44bda8')
        commit('setCorpHeadingColor', '#44bda8')

        return axios.post('/logging/writeActivityToQueue', userPayload).then((response) => {
            router.push('/')
        }, (err) => {
            router.push('/')
            console.log('err ', err)
        })
    },
    LOGOUTHORIZON ({ commit }, userRef) {
        let userId = userRef ? userRef.userId : 0
        let userPayload = {}
        userPayload.userId = userId
        userPayload.action = `LOGOUT`
        userPayload.activityCode = null
        userPayload.activityMessage = 'AUTHORIZED'
        userPayload.severityLevel = 'INFORMATION'
        userPayload.status = null
        userPayload.timeZone = dateHelpers.getUserTimeZone()
        userPayload.pageName = null
        userPayload.os = dateHelpers.userPlatForm().os.family
        userPayload.osVersion = dateHelpers.userPlatForm().os.version
        userPayload.browserName = dateHelpers.userPlatForm().name
        userPayload.browserVersion = dateHelpers.userPlatForm().version
        userPayload.device = dateHelpers.userPlatForm().product
        userPayload.deviceType = null
        // Additional logging
        userPayload.userAgent = navigator.userAgent
        if (navigator.userAgent.indexOf('gonative') > -1) {
            // IOS App
            userPayload.deviceType = 'IOS APP'
        } if (navigator.userAgent.indexOf('gonativeand') > -1) {
            // Andoird App
            userPayload.deviceType = 'ANDROID APP'
        }
        if (sessionStorage.getItem('corporateGiftingCode')) {
            sessionStorage.removeItem('corporateGiftingCode')
        }
        if (localStorage.getItem('corporateGiftingCode')) {
            localStorage.removeItem('corporateGiftingCode')
        }
        if (sessionStorage.getItem('corporateClientObject')) {
            sessionStorage.removeItem('corporateClientObject')
        }
        if (localStorage.getItem('corporateClientObject')) {
            localStorage.removeItem('corporateClientObject')
        }
        if (sessionStorage.getItem('corporateGiftInfoObject')) {
            sessionStorage.removeItem('corporateGiftInfoObject')
        }
        if (localStorage.getItem('corporateGiftInfoObject')) {
            localStorage.removeItem('corporateGiftInfoObject')
        }
        if (sessionStorage.getItem('corporateClientId')) {
            sessionStorage.removeItem('corporateClientId')
        }
        if (localStorage.getItem('corporateClientId')) {
            localStorage.removeItem('corporateClientId')
        }
        localStorage.removeItem('token')
        sessionStorage.removeItem('token')
        localStorage.removeItem('loggedUser')
        // localStorage.removeItem('corporateClientObject')
        sessionStorage.removeItem('switchClientObject')
        sessionStorage.removeItem('redirectPath')
        let loggedUserTemp = sessionStorage.getItem('loggedUserTemp') // User needs to be redirected to login (temporary) after interests are set
        if (loggedUserTemp) {
            sessionStorage.removeItem('loggedUserTemp')
        }
        commit('setUser', { user: null })
        commit('setHeaderAlertStatus', false)
        commit('setCorpHeaderColor', '#44bda8')
        commit('setCorpFooterColor', '#44bda8')
        commit('setCorpButtonColor', '#44bda8')
        commit('setCorpHeadingColor', '#44bda8')

        return axios.post('/logging/writeActivityToQueue', userPayload).then((response) => {
        }, (err) => {
            console.log('err ', err)
        })
        // router.push('/')
    },
    ME ({ commit }) {
        axios.get('api/users/me').then((response) => {
            commit('setUser', { user: response.data })
        }, (err) => {
            console.log(err)
        })
    },
    GETBILLINGHISTORY ({ commit }, { userId }) {
        return axios.get(`/profile/getBillingHistoryById/${userId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setBillingHistory', { billHistory: data.payload })
            } else {
                commit('setBillingHistory', { billHistory: null })
            }
        }, (err) => {
            commit('setBillingHistory', { billHistory: null })
            console.log('err ', err)
        })
    },
    DEFAULTIMAGESLIST ({ commit }) {
        return axios.get(`/profilepictures`).then((response) => {
            const { data: { data } } = response
            if (data) {
                commit('setDefaultImages', { imagesList: data })
            } else {
                commit('setDefaultImages', { imagesList: null })
            }
        }, (err) => {
            commit('setDefaultImages', { billHistory: null })
            console.log('err ', err)
        })
    },
    RESENDVALIDATIONCODE ({ commit }, email) {
        return axios.get(`/registration/resendConfirmationCode/${email}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error) {
                commit('setError', { error: { show: false, message: '' } })
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETPAYPALTOKEN ({ commit }) {
        return axios.get(`/braintree`).then((response) => {
            const { data: { data } } = response
            if (data) {
                commit('setPaypalToken', { token: data })
            } else {
                commit('setPaypalToken', { token: '' })
            }
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETCREDITCARDINFO ({ commit }, userId) {
        return axios.get(`profile/getCardLastDigits/${userId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setCreditCardInfo', { ccInfo: data.payload })
            } else {
                commit('setCreditCardInfo', { ccInfo: '' })
            }
        }, (err) => {
            console.log('err ', err)
        })
    },
    CANCELSUBSCRIPTION ({ commit }, userId) {
        return axios.post(`registration/cancelSubscriptionById/${userId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setError', { error: { show: false, message: '' } })
                // Update User Payload
                let logUser = localStorage.getItem('loggedUser')
                if (logUser) {
                    logUser = JSON.parse(localStorage.getItem('loggedUser'))
                    logUser.status = 'CANCELLED'
                    localStorage.setItem('loggedUser', JSON.stringify(logUser))
                }
                let logUserTemp = sessionStorage.getItem('loggedUserTemp')
                if (logUserTemp) {
                    logUserTemp = JSON.parse(sessionStorage.getItem('loggedUserTemp'))
                    logUserTemp.status = 'CANCELLED'
                    sessionStorage.setItem('loggedUserTemp', JSON.stringify(logUserTemp))
                }
                // logging out
                // localStorage.removeItem('token')
                // localStorage.removeItem('loggedUser')
                // let loggedUserTemp = sessionStorage.getItem('loggedUserTemp') // User needs to be redirected to login (temporary) after interests are set
                // if (loggedUserTemp) {
                //     sessionStorage.removeItem('loggedUserTemp')
                // }
                // commit('setUser', { user: null })
                // router.push('/')
            } else {
                commit('setError', { error: { show: true, message: '' } })
            }
        }, (err) => {
            console.log('err ', err)
        })
    },
    CREATEPLAYLIST ({ commit }, { playlist }) {
        return axios.post('playlists/insertUserPlaylist', playlist).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                return axios.get(`playlists/getAllUserPlaylists/${playlist.userId}`).then((response) => {
                    const { data: { data } } = response
                    if (data && !data.error && data.completed) {
                        commit('setUserPlaylists', { playlist: data.payload })
                    } else {
                        commit('setUserPlaylists', { playlist: null })
                        // commit('setError', { error: {show: true, message: errorMapping.getCustomErrorMessage(data.message)} })
                    }
                }, (err) => {
                    console.log('err ', err)
                    commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
                })
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    ADDVIDEOINPLAYLIST ({ commit }, { playlist }) {
        return axios.post('playlists/addVideoToUserPlaylist', playlist).then((response) => {
            const { data: { data } } = response
            if (data) {
                return axios.get(`playlists/getAllUserPlaylists/${playlist.userId}`).then((response) => {
                    const { data: { data } } = response
                    if (data && !data.error && data.completed) {
                        commit('setUserPlaylists', { playlist: data.payload })
                    } else {
                        commit('setUserPlaylists', { playlist: null })
                        // commit('setError', { error: {show: true, message: errorMapping.getCustomErrorMessage(data.message)} })
                    }
                }, (err) => {
                    console.log('err ', err)
                    commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
                })
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    REMOVEVIDEOFROMPLAYLIST ({ commit }, { playlist }) {
        return axios.post('playlists/deleteUserPlaylistVideo', playlist).then((response) => {
            const { data: { data } } = response
            if (data) {
                return axios.get(`playlists/getAllUserPlaylists/${playlist.userId}`).then((response) => {
                    const { data: { data } } = response
                    if (data && !data.error && data.completed) {
                        commit('setUserPlaylists', { playlist: data.payload })
                    } else {
                        commit('setUserPlaylists', { playlist: null })
                        // commit('setError', { error: {show: true, message: errorMapping.getCustomErrorMessage(data.message)} })
                    }
                }, (err) => {
                    console.log('err ', err)
                    commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
                })
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    REMOVEPLAYLIST ({ commit }, { playlist }) {
        console.log('payload', playlist)
        return axios.get(`playlists/inactivateUserPlaylist/${playlist.playlistId}`).then((response) => {
            const { data: { data } } = response
            if (data) {
                return axios.get(`playlists/getAllUserPlaylists/${playlist.userId}`).then((response) => {
                    const { data: { data } } = response
                    if (data && !data.error && data.completed) {
                        commit('setUserPlaylists', { playlist: data.payload })
                    } else {
                        commit('setUserPlaylists', { playlist: null })
                        // commit('setError', { error: {show: true, message: errorMapping.getCustomErrorMessage(data.message)} })
                    }
                }, (err) => {
                    console.log('err ', err)
                    commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
                })
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    SORTPLAYLISTVIDEOS ({ commit }, { playlist }) {
        console.log('payload', playlist)
        return axios.post('playlists/updUserVideoDispOrder/', playlist).then((response) => {
            console.log('sorting response', response.data)
            const { data: { data } } = response
            if (data) {
                return axios.get(`playlists/getAllUserPlaylists/${playlist.userId}`).then((response) => {
                    const { data: { data } } = response
                    if (data && !data.error && data.completed) {
                        commit('setUserPlaylists', { playlist: data.payload })
                    } else {
                        commit('setUserPlaylists', { playlist: null })
                        // commit('setError', { error: {show: true, message: errorMapping.getCustomErrorMessage(data.message)} })
                    }
                }, (err) => {
                    console.log('err ', err)
                    commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
                })
            } else {
                commit('setError', { error: { show: true, message: errorMapping.getCustomErrorMessage(data.message) } })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    GETUSERPLAYLISTS ({ commit }, userId) {
        return axios.get(`playlists/getAllUserPlaylists/${userId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setUserPlaylists', { playlist: data.payload })
            } else {
                commit('setUserPlaylists', { playlist: null })
                // commit('setError', { error: {show: true, message: errorMapping.getCustomErrorMessage(data.message)} })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    GET_TRENDING_PLAYLISTS ({ commit }) {
        return axios.get(`/playlists/getCuratedPlaylist`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setUserPlaylists', { playlist: data.payload })
            } else {
                commit('setUserPlaylists', { playlist: null })
                // commit('setError', { error: {show: true, message: errorMapping.getCustomErrorMessage(data.message)} })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    GETCORPPLAYLISTS ({ commit }, corpId) {
        return axios.get(`corporations/getCorporationPlaylists/${corpId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setUserPlaylists', { playlist: data.payload })
            } else {
                commit('setUserPlaylists', { playlist: null })
                // commit('setError', { error: {show: true, message: errorMapping.getCustomErrorMessage(data.message)} })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    GETCORPSHAREDVIDEOS ({ commit }, userId) {
        return axios.get(`corporations/getCorpUserSharedVideos/${userId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setCropUserSharedVideos', { vids: data.payload })
            } else {
                commit('setCropUserSharedVideos', { vids: null })
                // commit('setError', { error: {show: true, message: errorMapping.getCustomErrorMessage(data.message)} })
            }
        }, (err) => {
            console.log('err ', err)
        })
    },
    GET_USER_PLAYLISTS_PROFILE ({ commit }, payload) {
        return axios.get(`playlists/getUserIntegratedPlaylists/${payload[0]}/${payload[1]}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                console.log('playlists payload', data.payload)
                commit('setUserPlaylistsProfile', { playlists: data.payload })
            } else {
                commit('setUserPlaylistsProfile', { playlists: null })
                // commit('setError', { error: {show: true, message: errorMapping.getCustomErrorMessage(data.message)} })
            }
        }, (err) => {
            console.log('err ', err)
        })
    },
    GET_USER_PROGRESS_PROFILE ({ commit }, userId) {
        return axios.get(`profile/getProfileProgressTab/${userId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setUserProgressProfile', { playlists: data.payload })
            } else {
                commit('setUserProgressProfile', { playlists: null })
                // commit('setError', { error: {show: true, message: errorMapping.getCustomErrorMessage(data.message)} })
            }
        }, (err) => {
            commit('setUserProgressProfile', { playlists: null })
            console.log('err ', err)
        })
    },
    GETSHAREDPLAYLISTS ({ commit }, playlistId) {
        return axios.get(`playlists/getUserSharedPlaylist/${playlistId[0]}/${playlistId[1]}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setUserSharedPlaylists', { playlist: data.payload })
            } else {
                commit('setUserSharedPlaylists', { playlist: null })
                // commit('setError', { error: {show: true, message: errorMapping.getCustomErrorMessage(data.message)} })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    GET_USER_EMAIL_PREFRENCES ({ commit }, userId) {
        return axios.get(`/registration/getUserOptOuts/${userId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setEmailPreferences', { pref: data.payload })
            } else {
                commit('setEmailPreferences', { pref: null })
                // commit('setError', { error: {show: true, message: errorMapping.getCustomErrorMessage(data.message)} })
            }
        }, (err) => {
            console.log('err ', err)
            // commit('setError', { error: {show: true, message: 'An error occurred while processing the request'} })
        })
    },
    GETUSERPLAYLISTSWITHVIDEOS ({ commit }, userId) {
        return axios.get(`playlists/getAllUserPlaylistsWithVideos/${userId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setUserPlaylistsWithVideos', { playlist: data })
            } else {
                commit('setUserPlaylistsWithVideos', { playlist: null })
                // commit('setError', { error: {show: true, message: errorMapping.getCustomErrorMessage(data.message)} })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: { show: true, message: 'An error occurred while processing the request' } })
        })
    },
    GETCORPORATIONPINNEDMSGS ({ commit }, corpId) {
        return axios.get(`corporations/findCorporationAllAdminMessages/${corpId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setCorporationPinnedMsgs', { msgs: data.payload })
            } else {
                commit('setCorporationPinnedMsgs', { msgs: null })
                // commit('setError', { error: {show: true, message: errorMapping.getCustomErrorMessage(data.message)} })
            }
        }, (err) => {
            commit('setCorporationPinnedMsgs', { msgs: null })
            console.log('err ', err)
        })
    },
    UPLOAD_CORP_CSV_METADATA ({ commit }, payload) {
        console.log('payload of  file', payload.csv_file)
        return new Promise((resolve, reject) => {
            console.log('payload of  file', payload.csv_file)
            let formData = new FormData()
            formData.append('csv_file', payload.csv_file)
            formData.append('corporationId', payload.corporationId)
            formData.append('userId', payload.userId)
            console.log('form data', formData)
            return axios.post(`/corporations/uploadCorpMembersDetail2S3`, formData).then((response) => {
                const { data: { data } } = response
                resolve(data)
            }, (error) => {
                console.log('CREATE_EXPERT error ', error)
                reject(error)
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/users/actions.js